import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dchatfriendbuttons',
  templateUrl: './dchatfriendbuttons.component.html',
  styleUrls: ['./dchatfriendbuttons.component.sass']
})
export class DchatfriendbuttonsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
